export default "__VITE_ASSET__DNYT8a99__"